/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { SecurityRouting } from './security.routing';
interface Props {}

export const SecurityComponent = memo((props: Props) => {
  return (
    <>
      <SecurityRouting />
    </>
  );
});

export const SeguridadModule = lazyLoad(
  () => import('./security.module'),
  (module) => module.SecurityComponent
);
